import {
  orgMemberRole,
  workspaceMemberRole,
} from "@specsheet-common/shared-types";

/**
 * Whether assigning campaign Full Access should be rejected for this user.
 * Guests (org guest, workspace collaborator, or missing membership on invite)
 * must not receive Full Access; workspace Admin/Member and org Admin may.
 */
export const isGuestCampaignCollaboratorTarget = ({
  organisationRole,
  workspaceRole,
  isWorkspaceMembershipDeleted,
  treatMissingWorkspaceMembershipAsGuest = false,
}: {
  organisationRole: string | undefined;
  workspaceRole: string | undefined;
  isWorkspaceMembershipDeleted: boolean;
  treatMissingWorkspaceMembershipAsGuest?: boolean;
}): boolean => {
  const hasLiveWorkspaceMembership =
    Boolean(workspaceRole) && !isWorkspaceMembershipDeleted;

  if (treatMissingWorkspaceMembershipAsGuest && !hasLiveWorkspaceMembership) {
    return true;
  }

  if (organisationRole === orgMemberRole.GUEST) {
    return true;
  }

  if (organisationRole === orgMemberRole.ADMIN) {
    return false;
  }

  return (
    !hasLiveWorkspaceMembership ||
    (workspaceRole !== workspaceMemberRole.ADMIN &&
      workspaceRole !== workspaceMemberRole.MEMBER)
  );
};
